import React, { useState, useEffect, useContext, useRef } from "react";
import quizThumb from '../../assets/images/quiz-default.jpg';
import Footer from "../../components/dashboard/footer";
import SideMenu from "../student/SideMenu";
// import Sidebar from "../../components/dashboard/sidebar";
import Header from "../../components/dashboard/header";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { contentContext } from "../../context/contentContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import Loader from "../../components/loader";
import OpenSeadragon from "openseadragon";
import deepZoom from "../../assets/images/icons/Dna-dz.svg";



const CPCInfo = () => {
    let { id } = useParams();
    const transformRef = useRef(null);
    const viewerRef = useRef(null);
    const { clientInfo, setClientInfo, setAnswers } = useContext(contentContext)
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [loader, setLoader] = useState(false);

        // Add state for no cases
    const [noCases, setNoCases] = useState(false);
    const [casesLoaded, setCasesLoaded] = useState(false);


    const { state } = useLocation();
    const navigate = useNavigate();
    const [cpcQtns, setCpcQtns] = useState(null);
    // const [answers, setAnswersData] = useState(null);
    const [qdisplay, setQdisplay] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [popupImage, setPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [img, setImage] = useState("");
    const [popup, setPopup] = useState(false)
    const handleClosePopup = () => setPopup(false);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [activeField, setActiveField] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isAutoSliding, setIsAutoSliding] = useState(false);
    const [index, setIndex] = useState(-1);
    const [gallery, setGallery] = useState([]);
    const [currentImage, setcurrentImage] = useState(null);
    const [nextIndex, setnextIndex] = useState(null);
    const [nextImage, setnextImage] = useState(null);
    const [prevIndex, setprevIndex] = useState(null);
    const [prevImage, setprevImage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [selected, setSelected] = useState({});
    const [successMsg, setSuccessMsg] = useState(false)
    const [handleBackPopup, setHandleBackPopup] = useState(false)
    const [viewer, setViewer] = useState(null);

    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dragActive, setDragActive] = useState(false);

    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupPngImage, setPopupPngImage] = useState(null);
    const [dzipopupImage, setDZIPopupImage] = useState(false);
    const [clinicalPopupList, setClinicalPopupList] = useState([]);
    const [clinicalPopupIndex, setClinicalPopupIndex] = useState(0);
    const [isClinicalLoading, setIsClinicalLoading] = useState(false);
    const [dziImageList, setDziImageList] = useState([]);
    const [dziCurrentIndex, setDziCurrentIndex] = useState(0);
    const [isDziLoading, setIsDziLoading] = useState(false);
 const location = useLocation();

  // Destructure the state to get routeFrom
  const { routeFrom } = location.state || {}; 
 console.log("Route from:", routeFrom);
    useEffect(() => {
      //  debugger
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity


        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };

        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: false,
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });


        setViewer(osdViewer);
        osdViewer.addOnceHandler("open", () => setIsDziLoading(false));

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);
    const rotateImage = (angle) => {
        if (viewer) {
            const newRotation = (rotation + angle) % 360;
            viewer.viewport.setRotation(newRotation);
            setRotation(newRotation);
        }
    };

    const resetZoom = () => {
        if (viewer) {
            viewer.viewport.goHome();
            viewer.viewport.setRotation(0);
            setRotation(0);
        }
    };

    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        setDziImageList([]);
        setDziCurrentIndex(0);
        setIsDziLoading(false);
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };
    const buildTileSourceForFile = (file) => {
        let path = file.dziUrl || "";
        if (path.startsWith("/")) path = path.slice(1);
        const isDziURL = path.includes("output.dzi");
        if (isDziURL) {
            path = `${path}_files/`;
            return {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(imageCloudfront + path),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: file.width || 0, Height: file.height || 0 },
                },
            };
        }
        const url = encodeURI(`${imageCloudfront}${(file.sourcepath || file.filepath || "").replace(/ /g, "%20")}?auto=compress,format`);
        return { type: "image", url, buildPyramid: false };
    };

    const navigateDziImage = (newIndex) => {
        if (!dziImageList.length) return;
        const clamped = Math.max(0, Math.min(newIndex, dziImageList.length - 1));
        const file = dziImageList[clamped];
        if (!file) return;
        const tileSource = buildTileSourceForFile(file);
        if (viewer) {
            setIsDziLoading(true);
            viewer.open(tileSource);
            viewer.viewport.setRotation(0);
            viewer.addOnceHandler("open", () => setIsDziLoading(false));
        }
        setDziCurrentIndex(clamped);
        setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename);
        setDZIPopupImage(imageCloudfront + file.sourcepath);
        setRotation(0);
    };

    const navigateClinicalImage = (newIndex) => {
        if (!clinicalPopupList.length) return;
        const clamped = Math.max(0, Math.min(newIndex, clinicalPopupList.length - 1));
        setIsClinicalLoading(true);
        setPopupPngImage(clinicalPopupList[clamped]);
        setClinicalPopupIndex(clamped);
    };

    const handleClinicalPopupOpen = (list, index) => {
        setShowImagePopup(true);
        setIsClinicalLoading(true);
        setPopupPngImage(list[index]);
        setClinicalPopupList(list);
        setClinicalPopupIndex(index);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (showImagePopup && clinicalPopupList.length > 1) {
                if (e.key === "ArrowLeft") {
                    const ni = Math.max(0, clinicalPopupIndex - 1);
                    setIsClinicalLoading(true);
                    setPopupPngImage(clinicalPopupList[ni]);
                    setClinicalPopupIndex(ni);
                } else if (e.key === "ArrowRight") {
                    const ni = Math.min(clinicalPopupList.length - 1, clinicalPopupIndex + 1);
                    setIsClinicalLoading(true);
                    setPopupPngImage(clinicalPopupList[ni]);
                    setClinicalPopupIndex(ni);
                }
            }
            if (isPopupOpen && dziUrl && dziImageList.length > 1 && viewer) {
                if (e.key === "ArrowLeft") {
                    e.preventDefault();
                    navigateDziImage(dziCurrentIndex - 1);
                } else if (e.key === "ArrowRight") {
                    e.preventDefault();
                    navigateDziImage(dziCurrentIndex + 1);
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [showImagePopup, clinicalPopupIndex, clinicalPopupList, isPopupOpen, dziUrl, dziCurrentIndex, dziImageList, viewer]);

    useEffect(() => {
        if (gallery) {
            // console.log(gallery, index)
            const currentImage = gallery[index];
            setcurrentImage(currentImage)
            const nextIndex = (index + 1) % gallery.length;
            setnextIndex(nextIndex)
            const nextImage = gallery[nextIndex] || currentImage;
            setnextImage(nextImage)
            const prevIndex = (index + gallery.length - 1) % gallery.length;
            setprevIndex(prevIndex)
            const prevImage = gallery[prevIndex] || currentImage;
            setprevImage(prevImage)
        }

    }, [index]);

    useEffect(() => {
        if (currentImage) {
            const img = new Image();
            img.src = `${imageCloudfront}${currentImage?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`;
            img.onload = () => setIsLoading(false);
        }

    }, [currentImage]);

    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);

    const handlePopupload = (e) => {
        setPopupLoading(true)
        console.log(dziUrl, "dz")
    }

    useEffect(() => {
        const selectedLength = Object.keys(selected).length
        if (selectedLength > 0) {
            // Add event listener for popstate to detect when the user presses the back button
            const handlePopState = (event) => {

                // Display the popup
                setHandleBackPopup(true);
                // Prevent default action of going back
                event.preventDefault();
                console.log("Browser back button pressed.");

            };

            // Initially pushState to allow popstate to fire
            window.history.pushState({}, document.title, window.location.href);

            // Add popstate listener
            window.addEventListener("popstate", handlePopState);

            return () => {
                // Cleanup event listener when component unmounts
                window.removeEventListener("popstate", handlePopState);
            };
        }

    }, [selected]);

    useEffect(() => {
        // This function will handle the beforeunload event
        const handleBeforeUnload = (event) => {
            // Prevent the default browser prompt (e.g., "Changes you made may not be saved")
            event.preventDefault();
            // For most browsers to show a confirmation dialog
            event.returnValue = '';  // This triggers the native browser confirmation dialog (which we want to avoid)

            // Show custom popup instead of native browser dialog
            //   setHandleBackPopup(true);
        };

        // Add the event listener for beforeunload (when user attempts to reload/close the page)
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    const GetAnswersInfo = async () => {
        try {
            const response = await tmdbApi.answerInfo();
            //setAnswersData(response?.result);
        } catch {
            console.log("error");
        }
    };

    const [cancel, setCancel] = useState(false)
    const onCancel = () => {
       
        if(routeFrom === "completedQuiz"){
             localStorage.setItem("completedTab", "yes")
        navigate("/cpcmanagement");

        }else{
             localStorage.setItem("completedTab", "no")
                    navigate("/cpcmanagement");

        }
    };




    const getCaseInfo = async (caseid) => {
        const response = await tmdbApi.cpcCaseModuleInfo(caseid, moduleid);
        let qtns = []
        if (response?.result?.questionData?.length > 0) {

            qtns = response?.result?.questionData.map(qtn => {
                qtn['answers'] = [
                    { id: 1, selected: {}, percent: 0 },
                    { id: 2, selected: {}, percent: 0 },
                    { id: 3, selected: {}, percent: 0 },
                    { id: 4, selected: {}, percent: 0 }
                ]
                return qtn;
            })
            qtns = qtns.sort((a, b) => {
                return caseid.indexOf(a.caseid) - caseid.indexOf(b.caseid);
            });
        }
        return qtns
    }


    // const handleSelectChange = (inputValue, Index) => {
    //     setActiveField(Index)
    //     if (inputValue != "") {
    //         const results = answersdata.filter(option =>
    //             option.answer.toLowerCase().includes(inputValue.toLowerCase())
    //         );
    //         console.log('results', results)
    //         setFilteredOptions(results);
    //     } else {
    //         setFilteredOptions([]);
    //     }
    // };


    const [filteredOptionsMap, setFilteredOptionsMap] = useState({});

    const handleSelectChange = (qIndex, selectedOption, aIndex) => {

        setActiveField(aIndex);
        setSelected(prev => ({
            ...prev,
            [`${qIndex}_${aIndex}`]: selectedOption
        }));

        let rmpQtns = [...cpcQtns]
        rmpQtns[qIndex].answers[aIndex].selected = selectedOption;
        if (!selectedOption) {

            rmpQtns[qIndex].answers[aIndex].percent = 0;


        } else {
            let ansTmp = rmpQtns[qIndex].answers.filter(ans => ans.percent === 0)

            if (ansTmp.length === 4) {
                rmpQtns[qIndex].answers[aIndex].percent = 100;

            }
        }
        setCpcQtns(rmpQtns)


    };

    // const handleInputChange = (inputValue, qIndex, aIndex) => {

    //     setActiveField(aIndex);
    //     if (inputValue !== "") {
    //         const results = answersdata.filter(option =>
    //             option.answer.toLowerCase().includes(inputValue.toLowerCase())
    //         );
    //         setFilteredOptionsMap(prev => ({
    //             ...prev,
    //             [`${qIndex}_${aIndex}`]: results
    //         }));
    //     } else {
    //         setFilteredOptionsMap(prev => ({
    //             ...prev,
    //             [`${qIndex}_${aIndex}`]: []
    //         }));
    //     }
    // };
    //  const handleInputChange = (inputValue, Index) => {

    //         // const tmpQttns = [...cpcQtns];
    //         // tmpQttns[qtnId].answers[index].selected = value;
    //         // setCpcQtns(tmpQttns);

    //          setActiveField(Index)
    //         if (inputValue != "") {
    //             const results = answersdata.filter(option =>
    //                 option.answer.toLowerCase().includes(inputValue.toLowerCase())
    //             );
    //             console.log('results', results)
    //             setFilteredOptions(results);
    //         } else {
    //             setFilteredOptions([]);
    //         }
    //     };


    // const handlePercentChange = (qtnId, index, value) => {
    //     const tmpQttns = [...cpcQtns];
    //     tmpQttns[qtnId].answers[index].percent = value;
    //     setCpcQtns(tmpQttns);
    // };
    const [caseId, setCaseId] = useState(null)
    const [moduleid, setModuleid] = useState(null);

    const getCpcInfoById = async (id) => {
        let response = id ? await tmdbApi.cpcInfoById(id) : await tmdbApi.cpcInfo("ACTIVE");
        if (typeof response?.result === 'string') {
            alert("no active cpc")
        }
        if (response?.result?.length > 0) {
            setCaseId(response?.result[0]?.cases)
        }
        if (response?.result?.length > 0 && response?.result[0]?.moduleid) {
            setModuleid(response?.result[0]?.moduleid)
        }
    }

    useEffect(() => {
        // if (state?.caseid) {
        //     localStorage.setItem("quzcaseid", JSON.stringify(state?.caseid))
        //     localStorage.setItem("quzcpcid", state?.cpcid)
        // }
        getCpcInfoById(id)

    }, [])

// const fetchData = async () => {
//     setLoader(true);  // Start loader

//     try {
//         if (caseId?.length > 0) {
//             const casid = caseId.map(item => item.caseid);
//             const tmpData = await getCaseInfo(casid);

//             setCpcQtns(tmpData?.filter(Boolean) || []);
//         }
//     } 
//     catch (error) {
//         console.error("Error fetching case info:", error);
//     } 
//     finally {
//         setQdisplay(true);
//         setLoader(false);  // Stop loader
//     }
// };


const fetchData = async () => {
    setLoader(true);  // Start loader

    try {
        if (caseId?.length > 0) {
            const casid = caseId.map(item => item.caseid);
            const tmpData = await getCaseInfo(casid);

            // Check if tmpData is empty or undefined
            if (!tmpData || tmpData.length === 0 || tmpData.every(item => !item)) {
                setNoCases(true);
                setCpcQtns([]);
            } else {
                setNoCases(false);
                setCpcQtns(tmpData?.filter(Boolean) || []);
            }
        } else {
            // If caseId is empty, also show no cases
            setNoCases(true);
            setCpcQtns([]);
        }
    } 
    catch (error) {
        console.error("Error fetching case info:", error);
        setNoCases(true);
        setCpcQtns([]);
    } 
    finally {
        setCasesLoaded(true); // Mark cases as loaded
        setQdisplay(true);
        setLoader(false);  // Stop loader
    }
};


    useEffect(() => {

        if (caseId && moduleid) {
            fetchData();
        }


    }, [caseId, moduleid]);


    const customComponents = {
        DropdownIndicator: () => null, // Remove the dropdown indicator
        IndicatorSeparator: () => null, // Optionally remove the separator
    };


    const handlePercentChange = (qIndex, aIndex, value) => {
        value = Number(value)
        let rmpQtns = [...cpcQtns]
        if (value === '') {
            value = 0;
        }
        rmpQtns[qIndex].answers[aIndex].percent = parseInt(value || 0)
        setCpcQtns(rmpQtns)

    }

    // const handlePercentChange = (qIndex, aIndex, value) => {

    //     let newValue = parseInt(value, 10);
    //     if (isNaN(newValue)) newValue = 0;
    //     newValue = Math.max(0, Math.min(newValue, 100)); // Clamp between 0 and 100

    //     const updatedQuestions = [...cpcQtns];
    //     const answers = [...updatedQuestions[qIndex].answers];

    //     // Set the changed value
    //     answers[aIndex].percent = newValue;

    //     const remainingTotal = 100 - newValue;

    //     // Filter to only other answers that have a non-empty `selected`
    //     const otherIndexes = answers
    //         .map((ans, idx) => ({ idx, selected: ans.selected }))
    //         .filter(({ idx, selected }) => idx !== aIndex && selected?.value?.trim() !== "")
    //         .map(({ idx }) => idx);

    //     const originalOtherPercents = otherIndexes.map(i => answers[i].percent);
    //     const originalTotal = originalOtherPercents.reduce((sum, val) => sum + val, 0);

    //     if (originalTotal > 0) {
    //         let redistributed = 0;
    //         otherIndexes.forEach((idx, i) => {
    //             let newPercent = Math.floor((answers[idx].percent / originalTotal) * remainingTotal);
    //             answers[idx].percent = newPercent;
    //             redistributed += newPercent;
    //         });

    //         const diff = remainingTotal - redistributed;
    //         if (diff !== 0 && otherIndexes.length > 0) {
    //             answers[otherIndexes[0]].percent += diff;
    //         }
    //     } else {
    //         // Distribute remaining evenly if no original percent values
    //         const count = otherIndexes.length;
    //         if (count > 0) {
    //             const evenSplit = Math.floor(remainingTotal / count);
    //             const remainder = remainingTotal % count;

    //             otherIndexes.forEach((idx, i) => {
    //                 answers[idx].percent = evenSplit + (i === 0 ? remainder : 0);
    //             });
    //         }
    //     }

    //     updatedQuestions[qIndex].answers = answers;
    //     setCpcQtns(updatedQuestions);
    // };



    const onReset = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault()
        setresetpopup(true)
        // setSelected({})
    };

    const ErrorList = ({ errors }) => {
        if (!errors || errors.length === 0) {
            return null; // No errors to display
        }

        return (
            <div style={{ color: 'red' }}>
                <ul>
                    {errors.map((error, index) => (
                        <li key={index}>{error}</li>
                    ))}
                </ul>
            </div>
        );
    };

    const [error, setError] = useState([])


    // const handleSubmit = async (e) => {
    //     // let cpcQtnsTmp = cpcQtns.filter(qtn => {
    //     //     return qtn.answers.filter(ans => ans.selected && ans.selected.trim() !== '').length > 0;
    //     // });
    //     const validated = cpcQtns.map(qtn => {
    //         const selectedAnswers = qtn.answers.filter(ans =>
    //             Object.keys(ans.selected || {}).length > 0
    //         );

    //         const totalPercent = selectedAnswers.reduce(
    //             (sum, ans) => sum + (parseFloat(ans.percent) || 0),
    //             0
    //         );

    //         return {
    //             caseid: qtn.caseid,
    //             answers: selectedAnswers,
    //             casetitle: qtn.casetitle,
    //             selectedCount: selectedAnswers.length,
    //             totalPercent,
    //             valid: selectedAnswers.length > 0 && totalPercent === 100
    //         };
    //     });

    //     let isValid = validated.filter(val => val.totalPercent === 100)
    //     if (isValid.length === cpcQtns.length) {
    //         setError([])
    //         let res = await tmdbApi.addCpcParticipantAnswers(validated);
    //         if (res.result) {

    //         }

    //     } else {
    //         let err = []
    //         if (isValid.length == 0) {
    //             err.push("Please select atleast one option for question")
    //         }
    //         console.log(isValid,"isValid")

    //         setError(err)

    //     }
    // }

    const handleSubmit = async (e) => {
        const validated = cpcQtns.map((qtn, index) => {
            const selectedAnswers = qtn.answers.filter(ans =>
                Object.keys(ans.selected || {}).length > 0
            );

            const totalPercent = selectedAnswers.reduce(
                (sum, ans) => sum + (parseFloat(ans.percent) || 0),
                0
            );

            const valid = selectedAnswers.length > 0 && totalPercent === 100;

            return {
                caseid: qtn.caseid,
                answers: selectedAnswers,
                diagnosis: qtn.diagnosis,
                selectedCount: selectedAnswers.length,
                totalPercent,
                valid,
                index
            };
        });

        const invalidQuestions = validated.filter(val => !val.valid);
        console.log(cpcQtns)
        if (invalidQuestions.length === 0) {
            setError([]);

            let payload = {
                "cpcid": localStorage.getItem("quzcpcid"),
                "userid": localStorage.getItem("userId"),
                "cases": [],
                "projection": "clientcase"
            };
            validated.forEach((caseData) => {
                let answers = [];
                caseData.answers.forEach(ans => {
                    let ansObj = {
                        "answerid": ans?.selected?.value,
                        "answer": ans?.selected?.label,
                        "weightage": ans.percent
                    }
                    answers.push(ansObj)
                });
                let obj = {
                    "caseid": caseData.caseid,
                    "answers": answers
                }
                payload.cases.push(obj)
            })


            const res = await tmdbApi.addCpcParticipantAnswers(payload);

            if (res.result?.toLowerCase() === "cpc participant answer added successfully") {
                // success logic here
                setSuccessMsg(true)
            }
        } else {
            const errMessages = invalidQuestions.map(q => {
                if (q.selectedCount === 0) {
                    return `Question "${q.diagnosis}" requires at least one selected option.`;
                } else if (q.totalPercent !== 100) {
                    return `Total percentage for question "${q.diagnosis}" must equal 100%. Currently: ${q.totalPercent}%.`;
                }
                return '';
            });

            setError(errMessages);
        }
    };

    const refresh = () => {
        navigate("/cpc")
    }

    const handlePngPopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupPngImage(imageUrl)

    }


    const onResetConfirm = async (e) => {
        setresetpopup(false)
        setSelected({})
        fetchData();

    }
    const onResetReject = (e) => {
        setresetpopup(false)
        setError([])
    }
    const handlePopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupImage(imageUrl)
        console.log("imgUrllllllllllllllllllllllllllllll", imageUrl)
    }
    const getExtension = (filename) => {

        if (!filename) return null;
        let extType = filename.split('.').pop().toLowerCase();
        let valReturn = ".jpeg,.jpg,.png";
        if (extType === 'tiff' || extType === 'tif') {
            valReturn = ".tif,.tiff";
        }
        return valReturn
    };
    return (

        <div id="layout-wrapper">
            <Header />
            <SideMenu />

            <div className="main-content user-management cpc-info" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h4 className="mb-2 card-title" id="breadcrumb-title">

                                        </h4>

                                    </div>
                                    <div className="create-quiz-btn" onClick={() => onCancel()}>
                                        Back
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row table-data">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body cpc-management">

                                        <div className="cpc-completed-view-page">

                                            {/* {!qdisplay &&

                                                <div className="empty-state-body empty-record"  >
                                                    <div className="empty-state__message">
                                                        <p className="form-check font-size-16">Loading...</p>
                                                    </div>
                                                </div>

                                            } */}
                                             {loader ? <Loader/> : 
                                                casesLoaded && noCases ? (
                                                    // Show "No cases" message when no cases are found
                                                   <div className="empty-state-body empty-record"  >
                                                <div className="empty-state__message">
                                                    <span className="material-icons">summarize</span>
                                                    <p className="form-check font-size-16"><div className="alert alert-warning mt-3">No  Cases is present. </div></p>
                                                </div>
                                            </div>
                                                ) :  qdisplay && cpcQtns && (

                                                    <div className="cpc-img-showing">
                                                        {cpcQtns.map((item, qIndex) => (
                                                            <div key={qIndex} className="img-section-wrapper mb-2">
                                                                {/* 
                                                                <h3 className="mb-3 card-title">{
                                                                    item.diagnosis}</h3> */}
                                                                <h3 className="mb-3 card-title">Case {qIndex + 1}</h3>
                                                                <p dangerouslySetInnerHTML={{ __html: item?.clinicalhistory }} ></p>
                                                                <div className="col-md-12">
                                                                    <div className="d-flex col-lg-12 align-items-start justify-content-between">
                                                                        <label className="form_label col-3">HISTOLOGY PHOTOS</label>


                                                                    </div>
                                                                </div>
                                                                <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                    {item?.files?.map((file, fileIndex) => (
                                                                            <div
                                                                                key={fileIndex}
                                                                                
                                                                                className={`img me-2 ${item?.files?.length ? 'upload-static-img' : ''}`}
                                                                                onClick={(e) => {

                                                                                    let filepath = file?.sourcepath || file?.filepath || "";
                                                                                    let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`

                                                                                    setPopupOpen(true);
                                                                                    setImageDimensions({ width: file.width, height: file.height });
                                                                                    setDziImageList(item?.files || []);
                                                                                    setDziCurrentIndex(fileIndex);
                                                                                    setIsDziLoading(true);

                                                                                    let path = file.dziUrl || "";
                                                                                    if (path.startsWith("/")) path = path.slice(1);
                                                                                    let isDziURL = path.includes("output.dzi");
                                                                                    if (isDziURL) {
                                                                                        path = `${path}_files/`;
                                                                                        setDziUrl(imageCloudfront + path);
                                                                                    } else {
                                                                                        setDziUrl(imagePath);
                                                                                    }

                                                                                    setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                    setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                    handlePopupload(e);

                                                                                }}
                                                                            >
                                                                                <span className="material-symbols-outlined img_view">zoom_out_map</span>

                                                                                <span className="default-img">


                                                                                    <img src={file?.thumbnailUrl ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : (
                                                                                        file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom
                                                                                    )} alt={file?.originalFilename}
                                                                                    onError={(e) => {
                                                                                        e.currentTarget.onerror = null;
                                                                                        e.currentTarget.src = deepZoom;
                                                                                    }} />

                                                                                </span>




                                                                            </div>
                                                                        ))}
                                                                </div>

                                                                {item?.historyfiles && item?.historyfiles?.length !== 0 &&

                                                                    <div className="col-md-12">
                                                                        <div className="d-flex col-lg-12 align-items-start justify-content-between">
                                                                            <label className="form_label col-3">CLINICAL HISTORY PHOTOS </label>

                                                                        </div>
                                                                        <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">

                                                                            {item?.historyfiles?.length > 0 &&
                                                                                item.historyfiles.map((innerItem, key) => {
                                                                                    const imagePath = `${imageCloudfront}${innerItem?.sourcepath?.replace(/ /g, '%20')
                                                                                        }?auto=compress,format`;
                                                                                    return (

                                                                                        <div
                                                                                            className={`img me-2 ${item?.files?.length ? 'upload-static-img' : ''}`} key={key}
                                                                                            onClick={() => {
                                                                                                const list = (item?.historyfiles || []).map(f => `${imageCloudfront}${f?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format`);
                                                                                                handleClinicalPopupOpen(list, key);
                                                                                            }}
                                                                                        >
                                                                                            <span className="material-symbols-outlined img_view">zoom_out_map</span>

                                                                                            <img src={`${imageCloudfront}${innerItem?.sourcepath?.replace(/ /g, '%20')}?auto=compress,format&width=150`} alt="history" />



                                                                                        </div>


                                                                                    );
                                                                                })}
                                                                        </div>

                                                                    </div>
                                                                }


                                                            </div>
                                                        ))}
                                                    </div>
                                                )
                                            }

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", zIndex: 999, borderRadius: "18px" }}>
                        <div style={{ width: "98vw", height: "98vh", position: "relative", backgroundColor: "black", overflow: "hidden" }}>
                            {/* Header */}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 20px", height: "52px", background: "linear-gradient(135deg, #091918 0%, #215250 100%)", borderBottom: "1px solid rgba(255,255,255,0.08)", boxShadow: "0 2px 12px rgba(0,0,0,0.4)" }}>
                                <div style={{ width: "120px" }} />
                                {dziImageList.length > 1 ? (
                                    <div style={{ display: "flex", alignItems: "center", background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "30px", padding: "3px" }}>
                                        <button onClick={() => navigateDziImage(dziCurrentIndex - 1)} disabled={dziCurrentIndex === 0} title="Previous image (←)"
                                            style={{ border: "none", background: dziCurrentIndex === 0 ? "transparent" : "rgba(255,255,255,0.1)", color: dziCurrentIndex === 0 ? "rgba(255,255,255,0.25)" : "#ffffff", cursor: dziCurrentIndex === 0 ? "not-allowed" : "pointer", width: "34px", height: "34px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                            <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_left</span>
                                        </button>
                                        <span style={{ display: "flex", alignItems: "center", gap: "4px", padding: "0 12px", fontSize: "13px", fontWeight: "600", userSelect: "none", whiteSpace: "nowrap" }}>
                                            <span style={{ color: "#EA7F4A", fontWeight: "700" }}>{dziCurrentIndex + 1}</span>
                                            <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: "0 1px" }}>/</span>
                                            <span style={{ color: "rgba(255,255,255,0.6)" }}>{dziImageList.length}</span>
                                        </span>
                                        <button onClick={() => navigateDziImage(dziCurrentIndex + 1)} disabled={dziCurrentIndex === dziImageList.length - 1} title="Next image (→)"
                                            style={{ border: "none", background: dziCurrentIndex === dziImageList.length - 1 ? "transparent" : "rgba(255,255,255,0.1)", color: dziCurrentIndex === dziImageList.length - 1 ? "rgba(255,255,255,0.25)" : "#ffffff", cursor: dziCurrentIndex === dziImageList.length - 1 ? "not-allowed" : "pointer", width: "34px", height: "34px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                            <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_right</span>
                                        </button>
                                    </div>
                                ) : <div />}
                                <div style={{ width: "120px", display: "flex", justifyContent: "flex-end" }}>
                                    <button className="dz_close" onClick={closeDeepZoom} title="Close"
                                        style={{ border: "1px solid rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.07)", color: "#ffffff", borderRadius: "50%", width: "34px", height: "34px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                        <span className="material-symbols-outlined" style={{ fontSize: "18px", lineHeight: 1 }}>close</span>
                                    </button>
                                </div>
                            </div>

                            {/* Viewer */}
                            <div style={{ height: "calc(95vh - 80px)", width: "100%", position: "relative" }}>
                                <div id="openseadragon-viewer" ref={viewerRef} style={{ height: "100%", width: "100%" }} />
                                {isDziLoading && (
                                    <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.55)", zIndex: 20, pointerEvents: "none" }}>
                                        <div style={{ width: "52px", height: "52px", borderRadius: "50%", border: "4px solid rgba(255,255,255,0.15)", borderTopColor: "#EA7F4A", animation: "dz-spin 0.75s linear infinite" }} />
                                        <style>{`@keyframes dz-spin { to { transform: rotate(360deg); } }`}</style>
                                    </div>
                                )}
                                <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", color: "grey", fontSize: "2vw", fontWeight: "600", textTransform: "uppercase", letterSpacing: "2px", textShadow: "1px 1px 4px rgba(0,0,0,0.6)", pointerEvents: "none", zIndex: 10, userSelect: "none" }}>
                                    Copyright © 2026 DADI
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showImagePopup && (
                <div
                    style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.88)", zIndex: 1003, display: "flex", flexDirection: "column" }}
                    onClick={() => { setShowImagePopup(false); setClinicalPopupList([]); setClinicalPopupIndex(0); }}
                >
                    {/* Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 20px", height: "52px", flexShrink: 0, background: "linear-gradient(135deg, #091918 0%, #215250 100%)", borderBottom: "1px solid rgba(255,255,255,0.08)", boxShadow: "0 2px 12px rgba(0,0,0,0.4)" }}
                        onClick={e => e.stopPropagation()}>
                        <div style={{ width: "120px" }} />
                        {clinicalPopupList.length > 1 ? (
                            <div style={{ display: "flex", alignItems: "center", background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "30px", padding: "3px" }}>
                                <button onClick={() => navigateClinicalImage(clinicalPopupIndex - 1)} disabled={clinicalPopupIndex === 0} title="Previous image (←)"
                                    style={{ border: "none", background: clinicalPopupIndex === 0 ? "transparent" : "rgba(255,255,255,0.1)", color: clinicalPopupIndex === 0 ? "rgba(255,255,255,0.25)" : "#ffffff", cursor: clinicalPopupIndex === 0 ? "not-allowed" : "pointer", width: "34px", height: "34px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_left</span>
                                </button>
                                <span style={{ display: "flex", alignItems: "center", gap: "4px", padding: "0 12px", fontSize: "13px", fontWeight: "600", userSelect: "none", whiteSpace: "nowrap" }}>
                                    <span style={{ color: "#EA7F4A", fontWeight: "700" }}>{clinicalPopupIndex + 1}</span>
                                    <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: "0 1px" }}>/</span>
                                    <span style={{ color: "rgba(255,255,255,0.6)" }}>{clinicalPopupList.length}</span>
                                </span>
                                <button onClick={() => navigateClinicalImage(clinicalPopupIndex + 1)} disabled={clinicalPopupIndex === clinicalPopupList.length - 1} title="Next image (→)"
                                    style={{ border: "none", background: clinicalPopupIndex === clinicalPopupList.length - 1 ? "transparent" : "rgba(255,255,255,0.1)", color: clinicalPopupIndex === clinicalPopupList.length - 1 ? "rgba(255,255,255,0.25)" : "#ffffff", cursor: clinicalPopupIndex === clinicalPopupList.length - 1 ? "not-allowed" : "pointer", width: "34px", height: "34px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_right</span>
                                </button>
                            </div>
                        ) : <div />}
                        <div style={{ width: "120px", display: "flex", justifyContent: "flex-end" }}>
                            <button className="dz_close" onClick={() => { setShowImagePopup(false); setClinicalPopupList([]); setClinicalPopupIndex(0); }} title="Close"
                                style={{ border: "1px solid rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.07)", color: "#ffffff", borderRadius: "50%", width: "34px", height: "34px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span className="material-symbols-outlined" style={{ fontSize: "18px", lineHeight: 1 }}>close</span>
                            </button>
                        </div>
                    </div>
                    {/* Image area */}
                    <div style={{ flex: 1, position: "relative", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", overflow: "hidden" }}
                        onClick={e => e.stopPropagation()}>
                        {isClinicalLoading && (
                            <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.55)", zIndex: 20, pointerEvents: "none" }}>
                                <div style={{ width: "52px", height: "52px", borderRadius: "50%", border: "4px solid rgba(255,255,255,0.15)", borderTopColor: "#EA7F4A", animation: "dz-spin 0.75s linear infinite" }} />
                                <style>{`@keyframes dz-spin { to { transform: rotate(360deg); } }`}</style>
                            </div>
                        )}
                        <img
                            src={popupPngImage}
                            onLoad={() => setIsClinicalLoading(false)}
                            onError={() => setIsClinicalLoading(false)}
                            style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", display: "block", borderRadius: "4px", opacity: isClinicalLoading ? 0 : 1, transition: "opacity 0.2s ease" }}
                        />
                    </div>
                </div>
            )}
        </div>



    );
};

export default CPCInfo;